import { useContext, useState } from 'react'
import { getIn } from 'formik'
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Stack,
  Switch,
  Text,
  VStack,
  Text as ChakraText,
  PopoverContent,
  IconButton,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverTrigger,
} from '@chakra-ui/react'
import { colors } from '../../../../ui-kit'
import { Trans, useTranslation } from 'react-i18next'
import CMUploadForm from '../Details/CustomMetadataMlUploadForm'
import RemoveBgModal from '../Details/RemoveBgModal'
import AutoTagsModal from '../Details/AutoTagsModal'
import { checkCfRequired, hasPermission } from './uploadUtils'
import { FeaturesEnum } from '../../../../utils/features'
import { UserContext } from '../../../providers'
import { BsInfoCircleFill } from 'react-icons/bs'
import PostTransformationFields from './PostTransformationFields'
const MetaDataFieldsMlSettings = ({
  handleChange,
  values,
  cmFields,
  form,
  isDisabled,
}) => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)
  const [isModalOpen, ToggleModal] = useState<boolean>(false)
  const [isAutoTagsModalOpen, toggleAutoTagsModal] = useState(false)

  return (
    <VStack alignItems="flex-start" width="100%" spacing={'2em'}>
      <VStack
        spacing="2em"
        direction="column"
        alignItems="flex-start"
        width="60%"
      >
        <VStack width={'100%'} alignItems="flex-start">
          <FormControl
            marginTop="1em"
            isInvalid={Boolean(
              form.errors?.upload?.extensionsData &&
                form.touched?.upload?.extensionsData,
            )}
          >
            <FormLabel fontWeight={700} htmlFor="upload.extensionsData">
              {t('extensions', 'Extensions')}
            </FormLabel>
            <FormControl
              marginTop="1em"
              isInvalid={Boolean(
                form.errors?.upload?.extensionsData?.removeBg &&
                  form.touched?.upload?.extensionsData?.removeBg,
              )}
            >
              <HStack>
                <Checkbox
                  isChecked={values?.upload?.extensionsData?.removeBg}
                  name="upload.extensionsData.removeBg"
                  onChange={event => {
                    handleChange(event)
                    if (event.target.checked)
                      handleChange({
                        target: {
                          value: {
                            background: 'no_background',
                            bgColor: '#0450d5',
                            bgImageURL: '',
                            semiTransparentCheck: false,
                            shadowCheck: false,
                          },
                          name: 'upload.removeBgData',
                        },
                      })
                  }}
                >
                  {t('remove_background', 'Remove Background')}
                </Checkbox>
                {values?.upload?.extensionsData?.removeBg && (
                  <Button
                    onClick={() => {
                      ToggleModal(true)
                    }}
                    variant="link"
                    color={colors.appBlue}
                  >
                    Configure
                  </Button>
                )}
              </HStack>
              <FormErrorMessage>
                {form.errors?.upload?.extensionsData?.removeBg}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              marginTop="1em"
              isInvalid={Boolean(
                form.errors?.upload?.extensionsData?.aiTag &&
                  form.touched?.upload?.extensionsData?.aiTag,
              )}
            >
              <HStack>
                <Checkbox
                  isChecked={values?.upload?.extensionsData?.aiTag}
                  name="upload.extensionsData.aiTag"
                  onChange={event => {
                    handleChange(event)
                    if (event.target.checked)
                      handleChange({
                        target: {
                          value: [
                            {
                              maxTags: 5,
                              minConfidence: 70,
                              name: 'aws-auto-tagging',
                            },
                            {
                              maxTags: 5,
                              minConfidence: 70,
                              name: 'google-auto-tagging',
                            },
                          ],
                          name: 'upload.aiTagData',
                        },
                      })
                  }}
                >
                  {t('add_auto_tags', 'Add auto tags')}
                </Checkbox>
                {values?.upload?.extensionsData?.aiTag && (
                  <Button
                    onClick={() => {
                      toggleAutoTagsModal(true)
                    }}
                    variant="link"
                    color={colors.appBlue}
                  >
                    {t('configure', 'Configure')}
                  </Button>
                )}
              </HStack>
              <FormErrorMessage>
                {form.errors?.upload?.extensionsData?.aiTag}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              marginTop="1em"
              isInvalid={Boolean(
                form.errors?.upload?.extensionsData?.autoDescription &&
                  form.touched?.upload?.extensionsData?.autoDescription,
              )}
            >
              <HStack>
                <Checkbox
                  isChecked={values?.upload?.extensionsData?.autoDescription || false}
                  name="upload.extensionsData.autoDescription"
                  onChange={handleChange}
                >
                  {t('add_auto_description', 'Add auto description')}
                </Checkbox>
              </HStack>
              <FormErrorMessage>
                {form.errors?.upload?.extensionsData?.autoDescription}
              </FormErrorMessage>
            </FormControl>
            <FormErrorMessage>
              {form.errors?.upload?.extensionsData}
            </FormErrorMessage>
          </FormControl>
        </VStack>

        <RemoveBgModal
          isOpen={isModalOpen}
          onClose={() => {
            ToggleModal(false)
          }}
          removeBgData={values?.upload?.removeBgData}
          setRemoveBgData={removeBgData =>
            handleChange({
              target: {
                value: removeBgData,
                name: 'upload.removeBgData',
              },
            })
          }
        />
        <AutoTagsModal
          isOpen={isAutoTagsModalOpen}
          onClose={() => {
            toggleAutoTagsModal(false)
          }}
          aiTagData={values?.upload?.aiTagData}
          setAiTagData={aiTagData => {
            handleChange({
              target: {
                value: aiTagData,
                name: 'upload.aiTagData',
              },
            })
            if (!aiTagData?.length) {
              handleChange({
                target: {
                  value: false,
                  name: 'upload.extensionsData.aiTag',
                },
              })
            }
          }}
        />
      </VStack>

      <VStack spacing="2em" alignItems="flex-start">
        <FormControl
          isInvalid={Boolean(
            form.errors?.upload?.customCoordinatesOb &&
              form.touched?.upload?.customCoordinatesOb,
          )}
        >
          <FormLabel
            fontWeight={700}
            htmlFor="upload.customCoordinatesOb"
            marginBottom="1em"
          >
            {t('custom_focus_area', 'Custom focus area')}
          </FormLabel>

          <Stack display="flex" flexDirection="row">
            <FormControl
              marginTop="0.5rem"
              isInvalid={Boolean(
                getIn(form.errors, 'upload.customCoordinatesOb.x-coordinate') &&
                  getIn(
                    form.touched,
                    'upload.customCoordinatesOb.x-coordinate',
                  ),
              )}
              isRequired={checkCfRequired(values?.upload?.customCoordinatesOb)}
            >
              <FormLabel htmlFor="upload.customCoordinatesOb.x-coordinate">
                {t('x_coordinate', 'X coordinate')}
              </FormLabel>
              <Input
                id="upload.customCoordinatesOb.x-coordinate"
                name="upload.customCoordinatesOb.x-coordinate"
                placeholder="e.g. 10"
                value={values?.upload?.customCoordinatesOb?.['x-coordinate']}
                marginTop="5px"
                onChange={event => {
                  handleChange({
                    target: {
                      value: {
                        'x-coordinate': event?.target?.value,
                        'y-coordinate':
                          values?.upload?.customCoordinatesOb?.['y-coordinate'],
                        width: values?.upload?.customCoordinatesOb?.width,
                        height: values?.upload?.customCoordinatesOb?.height,
                      },
                      name: 'upload.customCoordinatesOb',
                    },
                  })
                }}
                width="90%"
              />
              <FormErrorMessage>
                {getIn(form.errors, 'upload.customCoordinatesOb.x-coordinate')}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              marginTop="0.5rem"
              isInvalid={Boolean(
                getIn(form.errors, 'upload.customCoordinatesOb.y-coordinate') &&
                  getIn(
                    form.touched,
                    'upload.customCoordinatesOb.y-coordinate',
                  ),
              )}
              isRequired={checkCfRequired(values?.upload?.customCoordinatesOb)}
            >
              <FormLabel htmlFor="upload.customCoordinatesOb.y-coordinate">
                {t('y_coordinate', 'Y coordinate')}
              </FormLabel>
              <Input
                id="upload.customCoordinatesOb.y-coordinate"
                name="upload.customCoordinatesOb.y-coordinate"
                placeholder="e.g. 10"
                value={values?.upload?.customCoordinatesOb?.['y-coordinate']}
                marginTop="5px"
                onChange={event => {
                  handleChange({
                    target: {
                      value: {
                        'x-coordinate':
                          values?.upload?.customCoordinatesOb?.['x-coordinate'],
                        'y-coordinate': event?.target?.value,
                        width: values?.upload?.customCoordinatesOb?.width,
                        height: values?.upload?.customCoordinatesOb?.height,
                      },
                      name: 'upload.customCoordinatesOb',
                    },
                  })
                }}
                width="90%"
              />
              <FormErrorMessage>
                {getIn(form.errors, 'upload.customCoordinatesOb.y-coordinate')}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              marginTop="0.5rem"
              isInvalid={Boolean(
                getIn(form.errors, 'upload.customCoordinatesOb.height') &&
                  getIn(form.touched, 'upload.customCoordinatesOb.height'),
              )}
              isRequired={checkCfRequired(values?.upload?.customCoordinatesOb)}
            >
              <FormLabel htmlFor="upload.customCoordinatesOb.height">
                {t('height', 'Height')}
              </FormLabel>
              <Input
                id="upload.customCoordinatesOb.height"
                name="upload.customCoordinatesOb.height"
                placeholder="e.g. 100"
                value={values?.upload?.customCoordinatesOb?.height}
                marginTop="5px"
                onChange={event => {
                  handleChange({
                    target: {
                      value: {
                        'x-coordinate':
                          values?.upload?.customCoordinatesOb?.['x-coordinate'],
                        'y-coordinate':
                          values?.upload?.customCoordinatesOb?.['y-coordinate'],
                        width: values?.upload?.customCoordinatesOb?.width,
                        height: event?.target?.value,
                      },
                      name: 'upload.customCoordinatesOb',
                    },
                  })
                }}
                width="90%"
              />
              <FormErrorMessage>
                {getIn(form.errors, 'upload.customCoordinatesOb.height')}
              </FormErrorMessage>
            </FormControl>
            <FormControl
              marginTop="0.5rem"
              isInvalid={Boolean(
                getIn(form.errors, 'upload.customCoordinatesOb.width') &&
                  getIn(form.touched, 'upload.customCoordinatesOb.width'),
              )}
              isRequired={checkCfRequired(values?.upload?.customCoordinatesOb)}
            >
              <FormLabel htmlFor="upload.customCoordinatesOb.width">
                {t('width', 'Width')}
              </FormLabel>
              <Input
                id="upload.customCoordinatesOb.width"
                name="upload.customCoordinatesOb.width"
                placeholder="e.g. 100"
                value={values?.upload?.customCoordinatesOb?.width}
                marginTop="5px"
                onChange={event => {
                  handleChange({
                    target: {
                      value: {
                        'x-coordinate':
                          values?.upload?.customCoordinatesOb?.['x-coordinate'],
                        'y-coordinate':
                          values?.upload?.customCoordinatesOb?.['y-coordinate'],
                        width: event?.target?.value,
                        height: values?.upload?.customCoordinatesOb?.height,
                      },
                      name: 'upload.customCoordinatesOb',
                    },
                  })
                }}
                width="90%"
              />
              <FormErrorMessage>
                {getIn(form.errors, 'upload.customCoordinatesOb.width')}
              </FormErrorMessage>
            </FormControl>
          </Stack>
        </FormControl>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('generate_unique_filenames_with_random_suffixes')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('generate_unique_filenames_with_random_suffixes_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.uniqueName}
            name="upload.uniqueName"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('overwrite_files_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('overwrite_files_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.overwriteFile}
            name="upload.overwriteFile"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('private_files_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('private_files_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.isPrivateFile}
            name="upload.isPrivateFile"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <HStack>
              <ChakraText fontWeight="700">
                {t('ensure_published_files_on_upload')}
              </ChakraText>
              {!user?.pricingPlan.featuresList.includes(
                FeaturesEnum.DRAFT_ASSETS,
              ) ? (
                <Popover trigger="hover">
                  <PopoverTrigger>
                    <Flex>
                      <IconButton
                        aria-label="Info icon"
                        icon={<BsInfoCircleFill />}
                        color={colors.appBlueyGrey}
                        size="sm"
                        variant="link"
                      />
                    </Flex>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverArrow />
                    <PopoverBody>
                      <Trans t={t} i18nKey="draft_asset_plan_info">
                        <Text>
                          Draft assets feature is not available in your current
                          plan.{' '}
                          <Link
                            isExternal
                            lineHeight={1.2}
                            href="https://docs.imagekit.io/features/user-access-management#media-library-restricted-access"
                          >
                            {t('learn_more', 'Learn more')}
                          </Link>
                          .
                          <br />
                          <Link
                            isExternal
                            href="https://imagekit.io/contact-us/"
                          >
                            Contact sales
                          </Link>{' '}
                          to enable this feature.
                        </Text>
                      </Trans>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              ) : null}
            </HStack>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('ensure_published_files_on_upload_description')}
              <Link href="https://docs.imagekit.io/media-library/overview/draft-assets">
                {t('read_more')}
              </Link>
            </ChakraText>
          </Box>
          {user?.pricingPlan.featuresList.includes(
            FeaturesEnum.DRAFT_ASSETS,
          ) ? (
            <Switch
              name="upload.publishFile"
              isDisabled={isDisabled}
              isChecked={values?.upload?.publishFile}
              onChange={event => {
                handleChange(event)
              }}
            />
          ) : (
            <Switch
              name="upload.publishFile"
              isDisabled={true}
              isChecked={values?.upload?.publishFile}
              onChange={event => {
                handleChange(event)
              }}
            />
          )}
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('overwrite_ai_tags_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('overwrite_ai_tag_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.overwriteAITags}
            name="upload.overwriteAITags"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('overwrite_tags_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('overwrite_tag_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.overwriteTags}
            name="upload.overwriteTags"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('overwrite_description_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('overwrite_description_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.overwriteDescription}
            name="upload.overwriteDescription"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="2rem">
          <Box>
            <ChakraText fontWeight="700">
              {t('overwrite_custom_metadata_during_upload')}
            </ChakraText>
            <ChakraText color={colors.appBattleshipGrey}>
              {t('custom_metadata_during_upload_description')}
            </ChakraText>
          </Box>
          <Switch
            isDisabled={isDisabled}
            isChecked={values?.upload?.overwriteCustomMetadata}
            name="upload.overwriteCustomMetadata"
            onChange={event => {
              handleChange(event)
            }}
          />
        </Flex>
        <FormControl
          isInvalid={Boolean(
            form.errors?.upload?.preTransformation &&
              form.touched?.upload?.preTransformation,
          )}
        >
          <FormLabel htmlFor="preTransformation" fontWeight={700} mb={0}>
            {t('pre_transformation', 'Pre transformation')}
          </FormLabel>
          <ChakraText color={colors.appBattleshipGrey} mb={'0.8em'}>
            {t('pre_transformation_info')}
            <Link href="https://docs.imagekit.io/features/pre-post-transformation">
              {t('read_more')}
            </Link>
          </ChakraText>
          <Input
            id="preTransformation"
            placeholder="w-40,h-30"
            name="upload.preTransformation"
            value={values?.upload?.preTransformation}
            width="60%"
            onChange={event => {
              handleChange(event)
            }}
          />
          <FormErrorMessage>
            {form.errors?.upload?.preTransformation}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={form.errors.upload?.postTransformation}>
          <FormLabel
            htmlFor="upload.postTransformation"
            fontWeight={700}
            mb={0}
          >
            {t('post_transformation', 'Post transformation')}
          </FormLabel>
          <ChakraText>
            <ChakraText color={colors.appBattleshipGrey} mb={'0.8em'}>
              {t('post_transformation_info')}
              <Link href="https://docs.imagekit.io/features/pre-post-transformation">
                {t('read_more')}
              </Link>
            </ChakraText>
          </ChakraText>
          <PostTransformationFields
            {...{
              form,
              postTransformation: values?.upload?.postTransformation,
              isDefault: true,
              isCommonSettings: false,
              type: null,
            }}
          />
        </FormControl>
      </VStack>

      {cmFields.length ? (
        <CMUploadForm cmFields={cmFields} form={form} />
      ) : (
        <></>
      )}
    </VStack>
  )
}

export default MetaDataFieldsMlSettings
